import { injectIntl } from "react-intl";
import React from "react";

const formatCurrency = (value) => {
  if (value == null || value === "" || isNaN(value)) {
    return "$0.0000";
  }
  return `$${parseFloat(value).toFixed(4)}`;
};

const formatDate = (value) => {
  if (!value) {
    return "-";
  }
  const date = new Date(value);
  if (isNaN(date.getTime())) {
    return "-";
  }
  return date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
};

const getCost = (item) => item?.cost_per_message;

const SmsPricingTable = (props) => {
  const list = props.list || [];

  if (list.length === 0) {
    return (
      <div className="PricingHistoryTableBody">No pricing history yet.</div>
    );
  }

  return (
    <div className="PricingHistoryTableBody">
      {list.map((item, index) => (
        <div key={item?._id || index} className="PricingHistoryRow">
          <div className="PricingHistoryRowCell PricingHistoryRowCellCost">
            {formatCurrency(getCost(item))}
          </div>
          <div className="PricingHistoryRowCell PricingHistoryRowCellDate">
            {formatDate(item?.createdAt || item?.created_at)}
          </div>
          <div className="PricingHistoryRowCell PricingHistoryRowCellNotes">
            {item?.notes?.trim() ? item.notes : "-"}
          </div>
          <div className="PricingHistoryRowActions">
            <button
              type="button"
              className="OfferDetailsEditButton"
              onClick={() => props.handleOpenEditPricing(item)}
            >
              <img
                alt="Edit"
                src="/media/icons/editIcon.svg"
                className="w-4 h-4"
              />
            </button>
            <button
              type="button"
              className="OfferDetailsDeleteButton"
              onClick={() => props.handleOpenDeletePricing(item)}
            >
              <img
                alt="Delete"
                src="/media/icons/deleteIcon.svg"
                className="w-4 h-4"
              />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default injectIntl(SmsPricingTable);
